import type { CopyShape } from "@tami/core/intl";

import type { TASKS_SCRIPT_COPY_PT_BR } from "../tasks-script.copy";

export const TASKS_SCRIPT_COPY_EN_US: CopyShape<typeof TASKS_SCRIPT_COPY_PT_BR> = {
  tasksIntro: {
    narrative: "Content hub: get to everything you've already planned and find any post in your history.",
  },
  tasksGrid: {
    narrative: "Filter by date, status, month or campaign — each card brings together platform, format and due date.",
    callout: "All your planned content in one place, with status and campaign in view.",
  },
  tasksModalOpen: {
    narrative: "Create a new plan in seconds — topic, network, format and due dates in a guided flow.",
    callout: "Create modal: plan content without leaving the Content hub.",
  },
  tasksModalTitle: {
    narrative: "Start with the topic: a series, collab, review or any idea you want to turn into content.",
    callout: "Set what the content is about — the starting point of every plan.",
  },
  tasksModalCampaign: {
    narrative: "Brand deals and organic in the same flow: link to an active campaign when it makes sense.",
    callout: "Connect the content to a campaign and keep deliverables organized.",
  },
  tasksModalPlatform: {
    narrative: "Pick the right network and Tãmi lines up the formats available for that platform.",
    callout: "Instagram, TikTok, YouTube and more — choose where this content goes live.",
  },
  tasksModalFormat: {
    narrative: "Reels, stories, feed or video: the format is part of the plan from the very first step.",
    callout: "Pick the content type and avoid rework when it's time to shoot.",
  },
  tasksModalDates: {
    narrative: "Set separate production and publish dates — shoot and post right on time.",
    callout: "When to shoot and when to post — two deadlines, zero calendar confusion.",
  },
  tasksRoteiroOpen: {
    narrative: "Every item has a script inside it. Opening it takes one click, and the text is already there.",
    callout: "Content hub / the task — the script lives inside it.",
  },
  tasksRoteiroToolbar: {
    narrative: "Real formatting and autosave: there's no save button to forget.",
    callout: "Brand comments stay right in the script, on the right line.",
  },
  tasksRoteiroSheet: {
    narrative: "Hook, body and close with the timing for each part — ready to shoot.",
    callout: "The script you actually shoot, not a loose notepad.",
  },
  tasksRoteiroImage: {
    narrative: "References go right in the text: the image locks in the framing before you shoot.",
    callout: "An image in the middle of the script, with a caption — text and reference together.",
  },
  tasksRoteiroEnd: {
    narrative: "And the script runs all the way to the close, with what the brand asked for already noted.",
    callout: "Scroll to the end: promo code, call to action and the brand's disclaimer.",
  },
  tasksOutro: {
    narrative: "From idea to finished script, in the same place where the deliverable is tracked.",
  },
};
